import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

// Attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token && config.url && config.url.startsWith("/admin")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const publicApi = {
  getSettings: () => api.get("/public/settings").then((r) => r.data),
  getDropdowns: () => api.get("/public/dropdowns").then((r) => r.data),
  register: (payload) => api.post("/register", payload).then((r) => r.data),
};

export const adminApi = {
  login: (username, password) =>
    api.post("/admin/login", { username, password }).then((r) => r.data),
  me: () => api.get("/admin/me").then((r) => r.data),
  listRegistrations: (params = {}) =>
    api.get("/admin/registrations", { params }).then((r) => r.data),
  updateStatus: (id, status) =>
    api.patch(`/admin/registrations/${id}/status`, { status }).then((r) => r.data),
  deleteRegistration: (id) =>
    api.delete(`/admin/registrations/${id}`).then((r) => r.data),
  getSettings: () => api.get("/admin/settings").then((r) => r.data),
  updateSettings: (payload) =>
    api.put("/admin/settings", payload).then((r) => r.data),
  stats: () => api.get("/admin/stats").then((r) => r.data),
};
